import qrTypes from "../constants/qrTypes";
import drawTypes from "../constants/drawTypes";
import errorCorrectionLevels from "../constants/errorCorrectionLevels";
import { DotType, Options, TypeNumber, ErrorCorrectionLevel, Mode, DrawType, Gradient } from "../types";

export interface RequiredOptions extends Options {
  type: DrawType;
  width: number;
  height: number;
  fit?: boolean;
  viewBox?: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  margin: number;
  data: string;
  qrOptions: {
    typeNumber?: TypeNumber;
    mode?: Mode;
    errorCorrectionLevel: ErrorCorrectionLevel;
  };
  bezel?: {
    depth: number;
    color?: string;
    colors?: string[];
  };
  imageOptions: {
    hideBackgroundDots: boolean;
    hideShape?: "square" | "radial";
    hideManualSize?: number;
    imageSize: number;
    crossOrigin?: string;
    margin: number;
    hidden?: boolean;
    width?: number;
    height?: number;
  };
  dotsOptions: {
    type: DotType;
    color: string;
    gradient?: Gradient;
    scale?: number;
  };
  backgroundOptions: {
    color: string;
    marginColor?: string;
    gradient?: Gradient;
  };
}

const defaultOptions: RequiredOptions = {
  type: drawTypes.canvas,
  width: 300,
  height: 300,
  fit: false,
  data: "",
  margin: 0,
  qrOptions: {
    typeNumber: qrTypes[0],
    mode: undefined,
    errorCorrectionLevel: errorCorrectionLevels.Q
  },
  imageOptions: {
    hideBackgroundDots: true,
    imageSize: 0.4,
    crossOrigin: undefined,
    margin: 0
  },
  dotsOptions: {
    type: "square",
    color: "#000"
  },
  backgroundOptions: {
    color: "#fff"
  }
};

export default defaultOptions;
